import { Card } from 'app/components/Card';
import React from 'react';
import renderTextContent, {
  TextContentType,
} from 'utils/text/renderTextContent';
import './InformationEquipmentListCard.less';
import clsx from 'clsx';
import { ReceivedInvitationsIcon } from 'app/components/icons';
import { Link } from 'react-router-dom';

interface Props {
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  items: TextContentType[];
  link?: string;
  linkLabel?: string;
  className?: string;
}

export default function InformationEquipmentListCard({
  icon: Icon = ReceivedInvitationsIcon,
  title,
  items,
  link,
  linkLabel,
  className,
}: Props) {
  if (!items.length) {
    return null;
  }

  return (
    <Card className={clsx('information-equipment-list-card', className)}>
      <Icon
        height={42}
        width={42}
        className="information-equipment-list-card__icon"
      />

      <div className="information-equipment-list-card__info-block">
        <h3 className="information-equipment-list-card__title">{title}</h3>

        <ul className="information-equipment-list-card__list">
          {items.map((item, index) => {
            return (
              <li key={index} className="information-equipment-list-card__item">
                {renderTextContent(item)}
              </li>
            );
          })}
        </ul>

        {link && linkLabel && (
          <Link to={link} className="information-equipment-list-card__link">
            {linkLabel}
          </Link>
        )}
      </div>
    </Card>
  );
}
